import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', () => {
  const drawerState = reactive({
    isOpen: false,
    formType: '',
    entityId: '',
    editMode: false,
  })

  const warehouseTaskState = reactive({
    current: {
      product: {},
      productServicesList: []
    }
  })

  const fetchData = async (url: string, options:object = { method: 'GET' }, extract = (r: unknown) =>
    (r as any)?.data) => {
    try {
      const res = await useApi(`api/${url}`, options)
      if (res?.success) return extract(res)
      return null
    } catch (e) {
      console.error(e)
      return null
    }
  }

  async function confirmResetPassword(token: string, password: string) {
    try {
      const response = await useApi('api/auth/confirm-reset-password', {
        method: 'POST',
        body: { token, password },
      })
      if (response.success) {
        return true
      }
      throw new Error(response.message || 'Password change failed')
    } catch (error) {
      console.error('Password change error:', error)
      return false
    }
  }

  return {
    drawerState,
    warehouseTaskState,
    fetchData,
    confirmResetPassword,
  }
})
